module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_4-9800c846cbe952b5df6ff521a9d772c9.svg";